'use client';

import Close from '@hc-frontend/core-icons/kit/close';
import Link from 'next/link';
import { useEffect, useState } from 'react';

export function PrivacyTermsBanner() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setTimeout(() => setVisible(false), 5000);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="hc-container-layout--exclude fixed bottom-0 z-[9999999999] bg-gray-50 py-16-24">
      <div className="hc-container-layout">
        <div className="flex items-center justify-between gap-16-16">
          <p className="hc-typography--disclaimer tablet:hc-typography--help-text">
            By using our site, you consent to our{' '}
            <Link href="/privacy-policy" target="_blank">
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link href="/terms" target="_blank">
              Terms of Use
            </Link>
            . If you do not agree to any of those, please do not use any portion
            of the site.
          </p>

          <button
            aria-label="close"
            type="button"
            onClick={() => setVisible(false)}
          >
            <Close className="size-24-24" />
          </button>
        </div>
      </div>
    </div>
  );
}
